// extracted by mini-css-extract-plugin
export var form = "_ds-0";